module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm05"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('em', [_vm._v("This volume is dedicated to all Americans as a memorial"), _c('br'), _vm._v("to our countrymen who volunteered in the armed forces"), _c('br'), _vm._v("of the United States during our greatest national crisis.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322f22f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm05.vue
// module id = 72
// module chunks = 0